import { useEffect } from "react";

const PaymentMethods = ({
    gateways,
    selectedPayment,
    setSelectedPayment,
}) => {

    useEffect(() => {
        if (gateways?.length > 0 && !selectedPayment) {
            setSelectedPayment(gateways[0].provider);
        }
    }, [gateways, selectedPayment, setSelectedPayment]);

    return (
        <div className="section">
            <h6 style={{ fontWeight: "bold" }}>
                SELECT A PAYMENT METHOD
            </h6>

            <div className="payment-options">
                {gateways?.map((pg, idx) => (
                    <label key={idx} className="payment-option">
                        <input
                            type="radio"
                            name="payment"
                            value={pg.provider}
                            checked={selectedPayment === pg.provider}
                            onChange={() => setSelectedPayment(pg.provider)}
                        />
                        <img
                            src={pg.logo}
                            alt={pg.provider}
                            className="payment-logo"
                        />
                    </label>
                ))}
            </div>
        </div>
    );
};

export default PaymentMethods;